export const getChatbotMessage = () => [
  {
    creator: "System",
    systemName: "employment",
    type: "chatbotQuestion",
    isFormal: true,
    text: "Hallo {{name}}.\nDanke nochmal für Ihre Bewerbung. Eine kurze Frage habe ich: für welches Unternehmen arbeiten Sie zurzeit?",
    createdDate: "2021-05-03T18:48:18+02:00",
    isSystemTemplate: true,
    name: "Arbeitgeber",
    id: "ZI7zisLHd5bWQrE7NbQn"
  },
  {
    systemName: "livingLocationBerlin",
    createdDate: "2021-05-03T18:48:19+02:00",
    name: "Berlin Wohnort",
    text: "Hallo {{name}}.\nKurze Frage: In welchem Bezirk von Berlin wohnst du?",
    creator: "System",
    isFormal: false,
    type: "chatbotQuestion",
    isSystemTemplate: true,
    id: "HcpLZ4PNb3wwjAaWJtRG"
  },
  {
    text: "Hallo {{name}},\nwir würden gerne mehr über Sie erfahren! Können Sie sich bitte kurz in 2-3 Sätzen vorstellen. Gerne auch in einer Sprachnachricht.\n\nViele Grüße\n{{recruiterName}}",
    name: "Vorstellen mit Sprachnachricht",
    creator: "System",
    isFormal: true,
    isSystemTemplate: true,
    createdDate: "2021-07-06T17:07:00+02:00",
    type: "chatbotQuestion",
    systemName: "introWithVoiceMessage",
    id: "LGWQsJrfRbUy3epeueDF"
  },
  {
    type: "chatbotQuestion",
    creator: "System",
    name: "Wohnort",
    text: "Hallo {{name}}.\nVielen Dank nochmal für Deine Bewerbung. Ich hoffe Dir geht es gut. Gerne würde ich Dich vorab fragen, wo Du aktuell wohnst? Solltest Du nicht in der Nähe wohnen, bist du ggf. umzugsbereit?\n\nViele Grüße,\n{{recruiterName}}",
    createdDate: "2021-06-03T09:59:44+02:00",
    isSystemTemplate: true,
    isFormal: false,
    systemName: "location",
    id: "jWshQevm0ogTb3rkZA5J"
  },
  {
    systemName: "relevantExperience",
    createdDate: "2021-06-18T15:33:12+02:00",
    isFormal: true,
    type: "chatbotQuestion",
    text: "Hallo {{name}},\nwir freuen uns sehr, Ihr Interesse geweckt zu haben! Um Ihren Erfahrungsschatz besser abschätzen zu können, benötige ich noch ein paar Informationen: Wie viel relevante Erfahrung bringen Sie für diese Stelle mit?\n\nViele Grüße,\n{{recruiterName}}",
    creator: "System",
    isSystemTemplate: true,
    name: "Relevante Erfahrung",
    id: "r30uWI8lpkiE0R05YKMM"
  },
  {
    text: "Hallo {{name}}.\nDanke nochmal für Deine Bewerbung. Eine kurze Frage habe ich: für welches Unternehmen arbeitest Du zurzeit?",
    createdDate: "2021-05-03T18:48:19+02:00",
    type: "chatbotQuestion",
    isSystemTemplate: true,
    name: "Arbeitgeber",
    creator: "System",
    systemName: "employment",
    isFormal: false,
    id: "NGmSbyqCgSbYmtN1zzF1"
  },
  {
    creator: "System",
    systemName: "experience",
    isFormal: true,
    type: "chatbotQuestion",
    createdDate: "2021-05-03T18:48:19+02:00",
    name: "Erfahrung",
    text: "Hallo {{name}}.\nKurze Frage: wie viel Erfahrung haben Sie als {{title}}?",
    isSystemTemplate: true,
    id: "tTSKjPajqfeVeZV5ClpQ"
  },
  {
    isFormal: false,
    systemName: "experience",
    createdDate: "2021-05-03T18:48:19+02:00",
    isSystemTemplate: true,
    creator: "System",
    name: "Erfahrung",
    type: "chatbotQuestion",
    text: "Hallo {{name}}.\nKurze Frage: wie viel Erfahrung hast Du als {{title}}?",
    id: "ip29x9vqULHYlG40m1A2"
  },
  {
    isFormal: true,
    createdDate: "2021-05-03T18:48:19+02:00",
    name: "Anfangszeit",
    text: "Hallo {{name}}.\nKurze Frage: Wann können Sie frühestens anfangen?",
    isSystemTemplate: true,
    type: "chatbotQuestion",
    creator: "System",
    systemName: "startDate",
    id: "J8ADilRMtAL4A1yXT11j"
  },
  {
    isSystemTemplate: true,
    creator: "System",
    text: "Hallo {{name}},\nvielen Dank für Ihre Bewerbung. Kurze Frage: Wann sind Sie am besten telefonisch erreichbar für ein Kennenlerngespräch?",
    createdDate: "2021-09-15T10:04:06+02:00",
    isFormal: true,
    systemName: "phoneCall",
    name: "Telefonat",
    type: "chatbotQuestion",
    id: "Wl7chChCLRx9IjAQdshQ"
  },
  {
    creator: "System",
    isSystemTemplate: true,
    name: "Selbstwerte",
    isFormal: true,
    systemName: "values",
    text: "Hallo {{name}}.\nDanke nochmal für Ihre Bewerbung. Kurze Frage: Welche zwei Eigenschaften machen Sie für uns zu einem interessanten Bewerber?",
    type: "chatbotQuestion",
    createdDate: "2021-05-03T18:48:19+02:00",
    id: "XjIclq320Qrg2tCnTVoZ"
  },
  {
    isFormal: false,
    creator: "System",
    text: "Hallo {{name}}.\nVielen Dank nochmal für Deine Bewerbung. Ich hoffe Dir geht es gut. Gerne würde ich Dich vorab fragen, wo Du aktuell wohnst? Solltest Du nicht in der Nähe wohnen, bist du ggf. umzugsbereit?\n\nViele Grüße,\n{{recruiterName}}",
    isSystemTemplate: true,
    name: "Wohnort",
    message:
      "Hallo {{name}}.\nVielen Dank nochmal für Deine Bewerbung. Ich hoffe Dir geht es gut. Gerne würde ich Dich vorab fragen, wo Du aktuell wohnst? Solltest Du nicht in der Nähe wohnen, bist du ggf. umzugsbereit?\n\nViele Grüße,\n{{recruiterName}}",
    type: "chatbotQuestion",
    systemName: "location",
    createdDate: "2021-06-02T18:06:03+02:00",
    id: "jWshQevm0ogTb3rkZA5J"
  },
  {
    isSystemTemplate: true,
    creator: "System",
    systemName: "location",
    text: "Hallo {{name}}.\nVielen Dank nochmal für Ihre Bewerbung. Ich hoffe, Ihnen geht es gut. Gerne würde ich Sie vorab fragen, wo Sie aktuell wohnen? Sollten Sie nicht in der Nähe wohnen, sind Sie ggf. umzugsbereit?\n\nViele Grüße,\n{{recruiterName}}",
    createdDate: "2021-09-09T15:56:23+02:00",
    type: "chatbotQuestion",
    name: "Wohnort",
    isFormal: true,
    id: "x4PDKvSsO0tDDlotqWae"
  },
  {
    text: "Hallo {{name}}.\nVielen Dank nochmal für Ihre Bewerbung. Kurze Frage: Für welches Unternehmen und in welchem Bereich arbeiten Sie derzeit?\n",
    type: "chatbotQuestion",
    systemName: "employmentWithDepartment",
    isFormal: true,
    isSystemTemplate: true,
    createdDate: "2021-05-03T18:48:19+02:00",
    name: "Arbeitgeber + Abteilung",
    creator: "System",
    id: "EbC1ZynNZXPsPyvoUQle"
  },
  {
    text: "Hallo {{name}}.\nKurze Frage: Wann kannst Du frühestens anfangen?",
    type: "chatbotQuestion",
    name: "Anfangszeit",
    isFormal: false,
    createdDate: "2021-05-03T18:48:19+02:00",
    isSystemTemplate: true,
    creator: "System",
    systemName: "startDate",
    id: "NFa6hNnJ88vfB6LcykTk"
  },
  {
    isSystemTemplate: true,
    isFormal: false,
    type: "chatbotQuestion",
    systemName: "values",
    creator: "System",
    name: "Selbstwerte",
    text: "Hallo {{name}}.\nDanke nochmal für deine Bewerbung. Kurze Frage: Welche zwei Eigenschaften machen Dich für uns zu einem interessanten Bewerber?",
    createdDate: "2021-05-03T18:48:19+02:00",
    id: "4V2d8LikAHf2fPaxwVIF"
  },
  {
    isSystemTemplate: true,
    systemName: "intro",
    isFormal: true,
    createdDate: "2021-05-03T18:48:19+02:00",
    name: "Vorstellung",
    creator: "System",
    type: "chatbotQuestion",
    text: "Hallo {{name}},\nkönnen Sie sich bitte in 2-3 Sätzen kurz vorstellen?\n\nViele Grüße,\n{{recruiterName}}",
    id: "I5Yv7aOd8qCAc35Z4Kxz"
  },
  {
    text: "Hallo {{name}},\nvielen Dank für deine Bewerbung. Kurze Frage: Wann bist Du am besten telefonisch erreichbar für ein Kennenlerngespräch?",
    isFormal: false,
    isSystemTemplate: true,
    name: "Telefonat",
    createdDate: "2021-09-13T17:34:02+02:00",
    type: "chatbotQuestion",
    creator: "System",
    systemName: "phoneCall",
    id: "RZul4q3cM8f00PDkIYKF"
  },
  {
    name: "Arbeitgeber + Abteilung",
    isFormal: false,
    isSystemTemplate: true,
    createdDate: "2021-05-03T18:48:19+02:00",
    creator: "System",
    type: "chatbotQuestion",
    text: "Hallo {{name}}.\nVielen Dank nochmal für Deine Bewerbung. Kurze Frage: Für welches Unternehmen und in welchem Bereich arbeitest Du derzeit?\n",
    systemName: "employmentWithDepartment",
    id: "oCU3GZHSi5SHlv1wj7FZ"
  },
  {
    systemName: "relevantExperience",
    isFormal: false,
    name: "Relevante Erfahrung",
    isSystemTemplate: true,
    text: "Hallo {{name}},\nwir freuen uns sehr, Dein Interesse geweckt zu haben! Um Deinen Erfahrungsschatz besser abschätzen zu können, benötige ich noch ein paar Informationen: Wie viel relevante Erfahrung bringst Du für diese Stelle mit?\n\nViele Grüße,\n{{recruiterName}}",
    creator: "System",
    type: "chatbotQuestion",
    createdDate: "2021-06-18T17:04:24+02:00",
    id: "2tOe5goCftajHeO2Bkfg"
  },
  {
    isSystemTemplate: true,
    isFormal: false,
    systemName: "locationClean",
    createdDate: "2021-06-14T11:17:26+02:00",
    text: "Hallo {{name}}.\nIch hoffe Dir geht es gut. Gerne würde ich Dich vorab fragen, wo Du aktuell wohnst? Solltest Du nicht in der Nähe wohnen, bist du ggf. umzugsbereit?\n\nViele Grüße,\n{{recruiterName}}",
    name: "Wohnort ohne Danke",
    creator: "System",
    type: "chatbotQuestion",
    id: "jvQru6Ozw1E3lV8NO6rG"
  },
  {
    text: "Hallo {{name}},\nkannst Du dich bitte in 2-3 Sätzen kurz vorstellen?\n\nViele Grüße,\n{{recruiterName}}",
    createdDate: "2021-05-03T18:48:19+02:00",
    creator: "System",
    isSystemTemplate: true,
    type: "chatbotQuestion",
    name: "Vorstellung",
    isFormal: false,
    systemName: "intro",
    id: "4ZX1k0NP7akQJu4QSOvI"
  }
];
